<template>
  <v-container class="container-card">
    <v-card>
      <TabelaBandeiras />
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ConsultaBandeira",

  components: {
    TabelaBandeiras: () =>
      import("@/components/empresa/bandeira/TabelaBandeiras")
  },

  methods: {
    ...mapActions({
      fetchView: "sistema/fetchView"
    })
  },

  mounted() {
    this.fetchView("Consulta Bandeira");
  }
};
</script>
